import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { landingPageDesignsKeys } from './landingPageDesignsKeys';
import { ILandingPageDesignResponse } from 'app/pages/admin/landing-pages-v2/types';
import { useToastError } from 'lib/hooks';

const duplicateLandingPageDesign = async (
  templateId: number
): Promise<ILandingPageDesignResponse> => {
  const response = await EXPRESS_API.post(
    `/superadmin/landing-page-designs/${templateId}/duplicate`
  );
  return response.data;
};

export const useDuplicateLandingPageDesignMutation = () => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();

  return useMutation(duplicateLandingPageDesign, {
    mutationKey: landingPageDesignsKeys.duplicate(),
    onSuccess: () => {
      successToast({ title: 'Template has been successfully duplicated' });
      queryClient.refetchQueries({
        queryKey: 'LANDING_PAGE_DESIGNS',
        exact: false,
      });
    },
    onError: error =>
      showError(error || 'An error occured while duplicating the UI Kit!'),
  });
};
